<div class="wt-steps-bar">
  <div class="wt-steps-bar__item" *ngFor="let step of steps">
    <wt-steps-bar-item [showActiveLabel]="showActiveLabel" [showAllLabels]="showAllLabels" [label]="step.label" [isActive]="isActive(step)"></wt-steps-bar-item>
  </div>
</div>
